// Character classes with unique starter deck + starter relic + tag color.

export const CLASSES = {
  rizzler: {
    id: 'rizzler',
    name: 'THE RIZZLER',
    tag: 'CHARISMA',
    color: '#ff007f',
    icon: '💋',
    desc: 'Slick talker. Draws more cards. Applies WEAK & VULN to trivialize enemies.',
    startingHp: 55,
    startingRelic: 'ringlight',
    starterDeck: [
      'yap','yap','yap','yap',
      'cope','cope','cope','cope',
      'malding','meditate',
    ],
    // Alt starter deck unlocks at mastery 3 (glowup)
    altStarterDeck: [
      'slap','slap','yap','yap',
      'cope','cope','cope','duocringe',
      'gaslight','parasocial',
    ],
  },
  sigma: {
    id: 'sigma',
    name: 'THE SIGMA',
    tag: 'STRENGTH',
    color: '#39ff14',
    icon: '🏋',
    desc: 'Lone wolf grindset. Stacks STRENGTH, hits big, low HP but hard hits.',
    startingHp: 50,
    startingRelic: 'burnerphone',
    starterDeck: [
      'yap','yap','yap','yap','yap',
      'cope','cope','cope',
      'aura','cringepunch',
    ],
    altStarterDeck: [
      'gooncannon','yap','yap','yap',
      'cope','cope','cope',
      'sigmagrind','compoundmog','followup',
    ],
  },
  gooner: {
    id: 'gooner',
    name: 'GOONER CHAD',
    tag: 'ENDURANCE',
    color: '#00e5ff',
    icon: '🛡',
    desc: 'Absolute unit. Tanks damage. Heals, blocks, outlasts.',
    startingHp: 75,
    startingRelic: 'energydrink',
    starterDeck: [
      'yap','yap','yap',
      'cope','cope','cope','cope','cope',
      'hydrate','seethe',
    ],
    altStarterDeck: [
      'yap','yap','cope','cope','cope','cope',
      'bidingtime','hardstance','swaptactic','chadstance',
    ],
  },
};

// Mastery milestone unlocks
export const MASTERY_MILESTONES = [
  { level: 1, name: 'Foil Starter Deck', desc: 'Your starter cards become foil.' },
  { level: 3, name: 'Alt Starter Deck', desc: 'Unlock alternate starter deck loadout.' },
  { level: 5, name: 'Signature Boon', desc: 'Bonus boon at run start.' },
  { level: 10, name: 'Prestige Title', desc: 'Unlock class prestige title.' },
];

export const CLASS_LIST = ['rizzler','sigma','gooner'];

export function classById(id) { return CLASSES[id]; }
export function starterDeckFor(classDef, mastery = 0, useAlt = false) {
  if (useAlt && mastery >= 3 && classDef.altStarterDeck) return [...classDef.altStarterDeck];
  return [...classDef.starterDeck];
}
